module.exports = __webpack_public_path__ + "static/media/stop.0325a451.svg";